// import React from "react";
// import Dropdown from "../DropDown";

// interface SourceDropdownProps {
//   selectedSource: string;
//   onSourceChange: (selectedSource: string) => void;
//   disabled: boolean;
//   className?: string;
//   onFocus?: () => void;
// }

// const SourceDropdown: React.FC<SourceDropdownProps> = ({
//   selectedSource,
//   onSourceChange,
//   className = "",
//   disabled,
//   onFocus,
// }) => {
//   const options = [
//     { value: "snowflake", label: "Snowflake" },
//     { value: "pi", label: "PI" },
//   ];

//   return (
//     <Dropdown
//       options={options}
//       selectedValue={selectedSource}
//       onValueChange={onSourceChange}
//       disabled={disabled}
//       className={className}
//       placeholder="Select Source"
//       onFocus={onFocus}
//     />
//   );
// };

// export default SourceDropdown;


// import React, { useState, useRef, useEffect } from "react";
// import { FaSearch } from "react-icons/fa";

// interface SourceMultiSelectDropdownProps {
//   selectedSources: string[];
//   onSourceChange: (selectedSources: string[]) => void;
//   disabled: boolean;
//   className?: string;
//   onFocus?: () => void;
// }

// const SourceMultiSelectDropdown: React.FC<SourceMultiSelectDropdownProps> = ({
//   selectedSources,
//   onSourceChange,
//   disabled,
//   className = "",
//   onFocus,
// }) => {
  
//   const options = [
//     { value: "nautilus", label: "Snowflake" },
//     { value: "pi", label: "PI" },
//   ];
  

//   const [open, setOpen] = useState(false);
//   const [search, setSearch] = useState("");
//   const wrapperRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     const handleClickOutside = (e: MouseEvent) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const toggleSelection = (value: string) => {
//     const updated = selectedSources.includes(value)
//       ? selectedSources.filter((v) => v !== value)
//       : [...selectedSources, value];

//     onSourceChange(updated);
//   };

//   const filteredOptions = options.filter((opt) =>
//     opt.label.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div ref={wrapperRef} className={`relative w-full ${className}`}>
//       {/* Displayed Input Box */}
//       <div
//         onClick={() => {
//           if (!disabled) {
//             setOpen((prev) => !prev);
//             onFocus && onFocus();
//           }
//         }}
//         className={`w-full min-h-[38px] p-2 border rounded-lg shadow-inner text-sm cursor-pointer flex flex-wrap gap-1 items-center ${
//           disabled ? "bg-[#f9f9f9] cursor-not-allowed" : "bg-white"
//         }`}
//       >
//         {/* Selected Badges */}
//         {selectedSources.length === 0 ? (
//           <span className="text-gray-400">Select Source</span>
//         ) : (
//           selectedSources.map((val) => {
//             const opt = options.find((o) => o.value === val);
//             return (
//               <span
//                 key={val}
//                 className="px-2 py-1 bg-blue-100 text-blue-700 rounded-md text-xs"
//               >
//                 {opt?.label}
//               </span>
//             );
//           })
//         )}
//       </div>

//       {/* Dropdown Panel */}
//       {open && !disabled && (
//         <div className="absolute z-50 mt-1 w-full bg-white border rounded-lg shadow-lg p-3 text-sm max-h-72 overflow-y-auto">
//           {/* Search */}
//           <div className="flex items-center mb-2 border border-gray-300 rounded-md px-2 py-1 bg-gray-50">
//             <FaSearch className="text-gray-400 mr-2" size={14} />
//             <input
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               placeholder="Search..."
//               className="w-full bg-transparent outline-none"
//             />
//           </div>

//           {/* Select All */}
//           <label className="flex items-center p-2 hover:bg-indigo-50 rounded-md cursor-pointer">
//             <input
//               type="checkbox"
//               checked={selectedSources.length === options.length}
//               onChange={() =>
//                 onSourceChange(
//                   selectedSources.length === options.length
//                     ? []
//                     : options.map((o) => o.value)
//                 )
//               }
//               className="mr-2"
//             />
//             Select All
//           </label>

//           {/* Options */}
//           <div className="mt-1">
//             {filteredOptions.length > 0 ? (
//               filteredOptions.map((opt) => (
//                 <label
//                   key={opt.value}
//                   className="flex items-center p-2 rounded-md hover:bg-indigo-50 cursor-pointer"
//                 >
//                   <input
//                     type="checkbox"
//                     checked={selectedSources.includes(opt.value)}
//                     onChange={() => toggleSelection(opt.value)}
//                     className="mr-2"
//                   />
//                   {opt.label}
//                 </label>
//               ))
//             ) : (
//               <p className="p-2 text-gray-400 text-center">No results found</p>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SourceMultiSelectDropdown;



import React, { useState, useRef, useEffect } from "react";
import { FaSearch } from "react-icons/fa";

interface SourceMultiSelectDropdownProps {
  selectedSources: string[];
  onSourceChange: (selectedSources: string[]) => void;
  disabled: boolean;
  className?: string;
  onFocus?: () => void;
}

const SourceMultiSelectDropdown: React.FC<SourceMultiSelectDropdownProps> = ({
  selectedSources,
  onSourceChange,
  disabled,
  className = "",
  onFocus,
}) => {
  
  const options = [
    { value: "nautilus", label: "Snowflake" },
    { value: "pi", label: "PI" },
  ];

  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const wrapperRef = useRef<HTMLDivElement>(null);

  // close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleSelection = (value: string) => {
    let updated = [...selectedSources];

    if (updated.includes(value)) {
      updated = updated.filter((v) => v !== value);
    } else {
      updated.push(value);
    }

    // Emit updated sources — MetricForm handles delete logic
    onSourceChange(updated);
  };

  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div ref={wrapperRef} className={`relative w-full ${className}`}>
      
      {/* Selection box */}
      <div
        onClick={() => {
          if (!disabled) {
            setOpen((prev) => !prev);
            onFocus && onFocus();
          }
        }}
        className={`w-full min-h-[38px] p-2 border rounded-lg shadow-inner 
          text-sm cursor-pointer flex flex-wrap gap-1 items-center 
          ${disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"}`}
      >
        {selectedSources.length === 0 ? (
          <span className="text-gray-400">Select Source</span>
        ) : (
          selectedSources.map((val) => {
            const opt = options.find((o) => o.value === val);
            return (
              <span
                key={val}
                className="px-2 py-1 bg-blue-100 text-blue-700 rounded-md text-xs"
              >
                {opt?.label}
              </span>
            );
          })
        )}
      </div>

      {/* Dropdown list */}
      {open && !disabled && (
        <div className="absolute z-50 mt-1 w-full bg-white border rounded-lg shadow-lg p-3 text-sm max-h-72 overflow-y-auto">

          {/* Search bar */}
          <div className="flex items-center mb-2 border border-gray-300 rounded-md px-2 py-1 bg-gray-50">
            <FaSearch className="text-gray-400 mr-2" size={14} />
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search..."
              className="w-full bg-transparent outline-none"
            />
          </div>

          {/* Select All */}
          <label className="flex items-center p-2 hover:bg-indigo-50 rounded-md cursor-pointer">
            <input
              type="checkbox"
              checked={selectedSources.length === options.length}
              onChange={() =>
                onSourceChange(
                  selectedSources.length === options.length
                    ? []
                    : options.map((o) => o.value)
                )
              }
              className="mr-2"
            />
            Select All
          </label>

          {/* Options */}
          <div className="mt-1">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((opt) => (
                <label
                  key={opt.value}
                  className="flex items-center p-2 rounded-md hover:bg-indigo-50 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={selectedSources.includes(opt.value)}
                    onChange={() => toggleSelection(opt.value)}
                    className="mr-2"
                  />
                  {opt.label}
                </label>
              ))
            ) : (
              <p className="p-2 text-gray-400 text-center">No results found</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SourceMultiSelectDropdown;
